module.exports = __webpack_public_path__ + "static/img/back.80207a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = P9/e
// module chunks = 1